export const reactionOptions = ['👍', '❤️', '👏', '😂', '😯', '😢', '😡'];
